//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useStore } from '../../../../pages/manage/store';
import { ContainerContext } from '../../../../utils';
import getEnterpriseEntitlements from '../../actions/get-enterprise-entitlements';

const selectedOrgSelector = (state) => state.selectedOrg?.code;

/** @param {import('@action-types/entitlement').EnterpriseEntitlementsQueryOptions} options */
const useEnterpriseEntitlements = ({ appType = 'S2S', ...options } = {}) => {
  /** @type {string | undefined} */
  const storeOrgId = useStore(selectedOrgSelector);

  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get('page') ?? '1');
  const urlOrder = searchParams.get('order') === 'ascending' ? 'ASC' : 'DESC';
  const urlSort = searchParams.get('sort') || 'CREATED';
  const urlPageIndex = page - 1;

  const orgId = options.orgId ?? storeOrgId;
  const pageIndex = options.pageIndex ?? urlPageIndex;
  const order = options.order ?? urlOrder;
  const sort = options.sort ?? urlSort;
  const pageSize = options.pageSize;

  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;

  const data = useQuery({
    queryKey: ['enterprise-entitlements', orgId, pageIndex, order, token, appType, sort, pageSize],
    queryFn: ({ signal }) =>
      getEnterpriseEntitlements({
        orgId,
        pageIndex,
        order,
        sort,
        pageSize,
        appType,
        token,
        signal,
      }),
    ...options,
    enabled: Boolean(token && orgId && (options.enabled ?? true)),
  });

  return data;
};

export default useEnterpriseEntitlements;
